import AppHeader from '../AppHeader'
export default {
  name: 'request-holiday-sent',
  components: {
    AppHeader
  },
  created () {
    var today = new Date()
    this.nextMonth = today.getMonth() + 2
    if(this.nextMonth === 13){
      this.nextMonth = 1
    }
  },
  data () {
    return {
      nextMonth: null
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    },
    goShiftList: function() {
      var dt = new Date()
      var ym = dt.getFullYear() + '-' + ("00" + (dt.getMonth()+2)).slice(-2)
      this.$router.push({ path: '/shift_list/' + ym})
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/scripts/request-holiday-sent.js